// extracted by mini-css-extract-plugin
export default {"headerDot":"DmbB0dgzZwoZsGGb8QLr"};